import { defineQuery } from 'next-sanity'

export const testimonialsBlockFields = `
  title,
  items[]{
    quote,
    author,
    rating
  }
`

export const TESTIMONIALS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "testimonials-block"][0]{
    _id,
    _type,
    ${testimonialsBlockFields}
  }
`)
